import { defineComponent as _defineComponent } from 'vue'
import { PropType, ref } from 'vue';
import NewModalDialog from '@/components/dialogs/NewModalDialog.vue';
import httpClient from '@/api/http-client';
import { useToast } from '@/components/helpers/vue2-helpers';
import i18nn from '@/plugins/i18n';
import { ApiError } from '@/api/api-error';
import useDocs from '@/components/composable/docs';
import { performDispatchAction } from '@/services/vue-utils';

interface UploadedFile {
  file: File;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ContactsImportDialog',
  props: {},
  emits: ['close'],
  setup(__props, { emit }) {

const props = __props;

const docs = useDocs();





const fileRecords = ref([] as UploadedFile[]);
const toast = useToast();

function close() {
  emit('close');
}

const lastError = ref(undefined as ApiError | undefined);

const onBeforeDelete = (fileRecord: UploadedFile) => {
  lastError.value = undefined;
  fileRecords.value = [];
};

const filesSelected = () => {
  lastError.value = undefined;
};

const uploadImportClicked = () => {
  httpClient.importContacts(fileRecords.value[0].file)
    .then((response: string) => {
      toast.success(i18nn.t('message.contact_import_successful'));
      console.log(response);
      fileRecords.value = [];
    }).then(() => {
      performDispatchAction('loadGuestbook', {}, { streamLoad: true });
    })
    .catch((error) => {
      const apiError = ApiError.fromError(error);
      lastError.value = apiError;
      toast.error(i18nn.t('error.contact_import_failed'));
      console.error(apiError);
    });
};


return { __sfc: true,docs, props, emit, fileRecords, toast, close, lastError, onBeforeDelete, filesSelected, uploadImportClicked, NewModalDialog }
}

})